import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import App from './AppRouter'
import { ErrorBoundary } from './ErrorBoundary'
// F-12. Both families are bundled locally (SIL OFL 1.1) and emitted as hashed WOFF2 by
// Vite. Nothing is fetched from a font CDN at runtime. Variable files cover every weight
// the interface uses, so no weight is browser-synthesised.
import '@fontsource-variable/inter'
import '@fontsource-variable/playfair-display'
import './styles.css'
import './design-system/product.css'
import './ux-v2.css'
import './storefront.css'
import './landing-immersive.css'

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </StrictMode>,
)

// AURION Ops has no offline mode and no companion shell, so it registers no service worker
// - and actively clears any that an earlier deployment of this origin left behind. A stale
// worker outlives the deployment that installed it and goes on serving that deployment's
// cached shell, which on an operations host means quietly showing a storefront that is not
// supposed to exist there any more.
if (import.meta.env.VITE_SURFACE === 'ops') {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.getRegistrations()
      .then(registrations => { for (const registration of registrations) void registration.unregister() })
      .catch(() => undefined)
  }
} else if ('serviceWorker' in navigator && (window.location.protocol === 'https:' || ['localhost','127.0.0.1'].includes(window.location.hostname))) {
  navigator.serviceWorker.register('/companion-sw.js').catch(() => undefined)
}
